import { Injectable } from '@angular/core';
import { GlobalVariable } from '.././config/service.config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class UnificadoService {
  url = GlobalVariable.API_Admision;
  urlApiCrm = GlobalVariable.BASE_API_URL;

  token = `Bearer ${JSON.parse(localStorage.getItem('token'))}`;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
  // .set('Authorization', this.token.replace(/["']/g, ''));
  constructor(private http: HttpClient) {
    // This is intentional
   }

  ObtieneValoresArancel(data) {

    let httpParams = new HttpParams()
      .set('Rut', data.Rut)
      .set('idProceso', data.idProceso)
      .set('codInstitucion', data.codInstitucion)
      .set('codSede', data.codSede)
      .set('codCarrera', data.codCarrera)
      .set('jornada', data.jornada)
      .set('tipoAlumno', data.tipoAlumno)
      .set('agnoIngreso', data.agnoIngreso)
      .set('agnoAcademico', data.agnoAcademico)
      .set('semestreAcademico', data.semestreAcademico)
      .set('tipoPrograma', 'PR')/*data.tipoPrograma*/
    return this.http.post(`${this.url}ServicioUnificado/ObtieneValoresArancel`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }
  GetProceso(idProceso: any) {
    const payload = {
      IdProceso: idProceso
    }
    return this.http.post(
      `${this.url}ServicioUnificado/getProceso`,
      payload,
      {
        headers: this.headersc
      });
  }
  ObtieneBecasMineduc(data: any) {
    return this.http.post(
      `${this.url}ServicioUnificado/ObtieneBecasMineduc`,
      data,
      {
        headers: this.headersc
      });
  }

  ObtieneBecaPsu(data: any) {
    let httpParams = new HttpParams()
      .set('idProceso', data.idProceso)
      .set('Rut', data.Rut)
      .set('CodArancel', data.CodArancel)
      .set('AgnoPsu', data.AgnoPsu)
      .set('PromedioPsu', data.PromedioPsu)

    return this.http.post(
      `${this.url}ServicioUnificado/ObtieneBecaPsu`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }

  ObtieneDescuento(data: any) {
    return this.http.post(
      `${this.url}ServicioUnificado/ObtieneDescuento`,
      data,
      {
        headers: this.headersc
      });
  }

  ObtieneBecaCAE(data: any) {
    let httpParams = new HttpParams()
      .set('idProceso', data.idProceso)
      .set('Rut', data.Rut)
      .set('CodArancel', data.CodArancel)
      .set('PromedioNem', data.PromedioNem)

    return this.http.post(
      `${this.url}ServicioUnificado/ObtieneBecaCAE`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }
  ObtieneTipoIngreso(data: any) {
    return this.http.post(
      `${this.url}ServicioUnificado/ObtieneTipoIngreso`,
      data,
      {
        headers: this.headersc
      });
  }

  ObtieneSituacionAcademica(data: any) {
    let httpParams = new HttpParams()
      .set('idProceso', data.idProceso)
      .set('rut', data.Rut)

    return this.http.post(
      `${this.url}ServicioUnificado/ObtieneSituacionAcademica`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }

  ValidaExisteMatricula(data: any) {
    let httpParams = new HttpParams()
      .set('idProceso', data.idProceso)

    return this.http.post(
      `${this.urlApiCrm}Generales/GetMatriculaCentralizada`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }

  ObtieneCupos(data: any) {
    return this.http.post(
      `${this.url}ServicioUnificado/ObtieneCupos`,
      data,
      {
        headers: this.headersc
      });
  }

  // GetProceso(idProceso: any) {
  //   const payload = {
  //     IdProceso: idProceso
  //   }
  //   return this.http.post(
  //     `${this.url}ServicioUnificado/getProceso`,
  //     payload,
  //     {
  //       headers: this.headersc
  //     });
  // }

  // ObtieneTipoIngreso(data: any) {
  //   return this.http.post(
  //     `${this.url}ServicioUnificado/ObtieneTipoIngreso`,
  //     data,
  //     {
  //       headers: this.headersc
  //     });
  // }

  RechazarDocumento(idProceso: string) {
    let httpParams = new HttpParams()
      .set('idProceso', idProceso)

    return this.http.post(
      `${this.url}ServicioUnificado/RechazarDocumento`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }
getMetodoFirma() : any {
    //debugger;
    return this.http.post(
      `${this.url}ServicioECert/RetornaMetodoFirma`,
      null,
      {
        headers: this.headersc
      });
  }
}
